import {Box} from '@primer/react'
import {AsyncChecksStatusBadge} from './AsyncChecksStatusBadge'
import {LoadingSkeleton} from '@github-ui/skeleton'
import {SignedCommitBadge as UiSignedCommitBadge} from '@github-ui/signed-commit-badge'
import type {DeferredCommitData} from '../types/commits-types'
import {useCommitsAppPayload} from '../hooks/use-commits-app-payload'

export const verifiedBadgeWidth = '62px'

export function SignedCommitBadge({deferredData}: {deferredData: DeferredCommitData | undefined}) {
  const {helpUrl} = useCommitsAppPayload()

  return (
    <>
      {!deferredData && (
        <LoadingSkeleton variant="rounded" sx={{display: ['none', 'flex'], width: verifiedBadgeWidth}} />
      )}
      {deferredData && (
        <UiSignedCommitBadge
          hasSignature={true}
          verificationStatus={deferredData.verifiedStatus}
          signature={{helpUrl, ...deferredData.signatureInformation!}}
        />
      )}
    </>
  )
}

export function CommitChecksStatusBadge({
  deferredData,
  oid,
}: {
  deferredData: DeferredCommitData | undefined
  oid: string
}) {
  let checkStatusCount = ''
  try {
    checkStatusCount = deferredData?.statusCheckStatus?.short_text?.split('checks')[0]?.trim() || ''
  } catch {
    //noop
  }

  return (
    <>
      {!deferredData && <LoadingSkeleton variant="rounded" sx={{display: ['none', 'flex'], width: '20px'}} />}
      {deferredData?.statusCheckStatus && <Box sx={{display: ['none', 'inherit'], ml: 1}}>&middot;</Box>}
      <Box sx={{display: ['none', 'inherit']}}>
        <AsyncChecksStatusBadge
          oid={oid}
          status={deferredData?.statusCheckStatus?.state}
          descriptionString={checkStatusCount}
        />
      </Box>
    </>
  )
}

try{ SignedCommitBadge.displayName ||= 'SignedCommitBadge' } catch {}
try{ CommitChecksStatusBadge.displayName ||= 'CommitChecksStatusBadge' } catch {}